import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Title3, Caption1, Callout } from '../../../components/Typography';
import PaymentMethodPreview from '../../PaymentMethods/components/PaymentMethodPreview';
import ConfirmDelete from '../../PaymentMethods/components/ConfirmDelete';
import { AddNewPaymentMethodButton } from '../../../components/Buttons';
import { SelectPaymentMethodButton } from '../../../components/Buttons';
import PaymentMethodFormContainer from '../../PaymentMethods/PaymentMethodForm/PaymentMethodFormContainer';
import SelectPaymentMethodFormContainer from '../../PaymentMethods/SelectPaymentMethodForm/SelectPaymentMethodFormContainer';
import PayOnArrivalCard from '../../PaymentMethods/components/PayOnArrivalCard';
import { connect } from 'react-redux';
import ApplePayForm from '../../PaymentMethods/ApplePayPayment/ApplePayForm';
import { Box } from '@material-ui/core';
const Wrapper = styled.div`
  display: ${(props) => (props.isForCheckoutPage ? 'grid' : 'block')};
  grid-template-columns: ${(props) =>
    props.isForCheckoutPage ? '150px 1fr' : 'auto auto'};
  justify-content: space-between;
  grid-gap: ${(props) => (props.isForCheckoutPage ? '0' : '10px')};
  margin-bottom: 30px;

  @media (max-width: 786px) {
    grid-gap: 24px;
    grid-template-columns: 1fr;
  }
`;

const PaymentMethodPreviewWrapper = styled.div`
  padding-left: ${(props) => (props.isForCheckoutPage ? '180px' : 0)};
  grid-column: ${(props) => (props.isForCheckoutPage ? '' : '1 / -1')};
  justify-self: 'normal';
  width: 100%;
  @media (max-width: 786px) {
    padding-left: 0;
  }
`;

const PaymentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ChangeButton = styled(Caption1)`
  cursor: pointer;
  justify-self: flex-end;
  margin-top: 12px;
  color: ${(props) => props.color || props.theme.clickableTextColor};

  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
    transition: all 0.25s ease;
  }
`;

const Title3Wrapper = styled(Title3)`
 text-transform: ${(props) => props.theme.reviewCheckoutPageTitle};
   /* border-bottom: ${(props) =>
     props.categoriesBarSelectedBorderColorWidth} solid
   ${(props) => props.theme.primaryColor}; */
  margin-bottom: ${(props) => (props.isForCheckoutPage ? 'auto' : '10px')};
  font-weight: ${(props) => (props.isForCheckoutPage ? '600' : 'normal')};
  font-size: ${(props) => (props.isForCheckoutPage ? 'inherit' : '16px')};
  width: max-content;
  padding-top: 30px;  
  :after {
    content: ""; 
    display: block; 
    width: calc(100% + 2px);
    padding-top: 2px; 
    border-bottom: ${(props) =>
      props.isForCheckoutPage
        ? `${props.categoriesBarSelectedBorderColorWidth} solid
       ${props.theme.categoriesBarSelectedBorderColor}`
        : ''};
  }
`;

const CalloutWrapper = styled(Callout)`
  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
    transition: all 0.25s ease;
  }
`;

const CartPaymentMethod = ({
  paymentMethods,
  defaultPaymentMethod,
  isForCheckoutPage,
  noDialogBackground,
  showGiftCardModal,
  initiateReloadGiftCard,
  reloadGiftCard,
  isForGiftCard,
  setDefaultPaymentMethod,
  paymentMethodSelectionFormIsVisible,
  showPaymentMethodSelectionForm,
  showConfirmDeletePaymentMethod,
  hideConfirmDeletePaymentMethod,
  paymentMethodsReducer,
  deletePaymentMethod,
  sourceConfig,
  isLoyaltyOnlyEnabled,
  selectedPaymentMethod,
  showSelectPaymentMethodForm,
  resetGiftCardReducer,
  isPayOnArrival,
  validatedCart,
  isGiftCardModalVisible,
}) => {
  const filteredPaymentMethods =
    paymentMethods && paymentMethods.length > 0
      ? paymentMethods
      : // paymentMethods.filter(
        //     paymentMethod => paymentMethod.type != 'gift_card'
        //   )
        null;

  useEffect(() => {
    isForGiftCard &&
      filteredPaymentMethods &&
      filteredPaymentMethods.length > 0 &&
      filteredPaymentMethods.find((method) => method.is_preferred) &&
      !filteredPaymentMethods
        .find((method) => method.is_preferred)
        .hasOwnProperty('id') &&
      setDefaultPaymentMethod(filteredPaymentMethods[0].id);
  }, []);

  const preferredPaymentMethod = filteredPaymentMethods
    ? filteredPaymentMethods.find((method) => method.is_preferred)
    : null;
  const {
    // requestingGetPaymentMethods,
    confirmDeletePaymentMethodIsVisible,
    requestingDeletePaymentMethod,
  } = paymentMethodsReducer;

  const [cardIdToDelete, setCardIdToDelete] = useState(null);

  useEffect(() => {
    if (!confirmDeletePaymentMethodIsVisible) {
      setCardIdToDelete(null);
    }
  }, [requestingDeletePaymentMethod]);

  const handleCancelDeletePaymentMethod = () => {
    setCardIdToDelete(null);
    hideConfirmDeletePaymentMethod();
  };

  const initiateDeletePaymentMethod = (cardId) => {
    setCardIdToDelete(cardId);
    showConfirmDeletePaymentMethod();
  };

  const handleDeletePaymentMethod = () => deletePaymentMethod(cardIdToDelete);
  const handleChangePaymentMethod = (e) => {
    e.stopPropagation();
    showPaymentMethodSelectionForm(true);
  };
  const hasPaymentMethods = paymentMethods && paymentMethods.length > 0;
  return (
    <Wrapper isForCheckoutPage={isForCheckoutPage}>
      <Title3Wrapper
        id='CardPaymentMethod-Title'
        isForCheckoutPage={isForCheckoutPage}
      >
        Payment Method:
      </Title3Wrapper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
        }}
      >
        {!isForGiftCard ? (
          isLoyaltyOnlyEnabled &&
          !selectedPaymentMethod &&
          !defaultPaymentMethod ? (
            <SelectPaymentMethodButton id='CartPaymentMethod-NewPaymentMethodButton' />
          ) : isLoyaltyOnlyEnabled && selectedPaymentMethod === 'poa' ? (
            <PaymentMethodPreviewWrapper isForCheckoutPage={isForCheckoutPage}>
              <PayOnArrivalCard />
              <ChangeButton
                id='CartPaymentMethod-ChangeButton'
                onClick={() => showSelectPaymentMethodForm(true)}
              >
                <CalloutWrapper>Change</CalloutWrapper>
              </ChangeButton>
            </PaymentMethodPreviewWrapper>
          ) : hasPaymentMethods ? (
            <PaymentMethodPreviewWrapper isForCheckoutPage={isForCheckoutPage}>
              <PaymentMethodPreview
                id='CartPaymentMethod-PaymentMethodPreview'
                paymentMethod={
                  defaultPaymentMethod || paymentMethods?.[0] || null
                }
                showPaymentMethodSelectionForm={showPaymentMethodSelectionForm}
                isForCheckoutPage={isForCheckoutPage}
                showGiftCardModal={showGiftCardModal}
                initiateReloadGiftCard={initiateReloadGiftCard}
                initiateDeletePaymentMethod={initiateDeletePaymentMethod}
                reloadGiftCard={reloadGiftCard}
                setDefaultPaymentMethod={setDefaultPaymentMethod}
                sourceConfig={sourceConfig}
                isForGiftCard={isForGiftCard}
                confirmDeletePaymentMethodIsVisible={
                  confirmDeletePaymentMethodIsVisible
                }
                requestingDeletePaymentMethod={requestingDeletePaymentMethod}
              />

              {!isLoyaltyOnlyEnabled ? (
                <ChangeButton
                  id='CartPaymentMethod-ChangeButton'
                  onClick={() => {
                    if (isPayOnArrival) {
                      showSelectPaymentMethodForm(true);
                    } else {
                      showPaymentMethodSelectionForm(true);
                    }
                  }}
                >
                  {paymentMethods && paymentMethods.length > 0 ? (
                    <CalloutWrapper>Change</CalloutWrapper>
                  ) : null}
                </ChangeButton>
              ) : (
                <ChangeButton
                  id='CartPaymentMethod-ChangeButton'
                  onClick={() => showSelectPaymentMethodForm(true)}
                >
                  <CalloutWrapper>Change</CalloutWrapper>
                </ChangeButton>
              )}
            </PaymentMethodPreviewWrapper>
          ) : (
            <AddNewPaymentMethodButton
              id='CartPaymentMethod-NewPaymentMethodButton'
              isForCheckoutPage={isForCheckoutPage}
              noDialogBackground={noDialogBackground}
              showChangePaymentMethodButton
              showSelectPaymentMethodForm={(bool) =>
                showSelectPaymentMethodForm(bool)
              }
            />
          )
        ) : filteredPaymentMethods &&
          filteredPaymentMethods.length > 0 &&
          preferredPaymentMethod ? (
          <PaymentMethodPreviewWrapper isForCheckoutPage={false}>
            {preferredPaymentMethod.type !== 'gift_card' && (
              <PaymentMethodPreview
                id='CartPaymentMethod-PaymentMethodPreview'
                paymentMethod={preferredPaymentMethod}
                isForCheckoutPage={isForCheckoutPage}
                showGiftCardModal={showGiftCardModal}
                initiateReloadGiftCard={initiateReloadGiftCard}
                reloadGiftCard={reloadGiftCard}
                setDefaultPaymentMethod={setDefaultPaymentMethod}
                paymentMethodSelectionFormIsVisible={
                  paymentMethodSelectionFormIsVisible
                }
                showPaymentMethodSelectionForm={showPaymentMethodSelectionForm}
                sourceConfig={sourceConfig}
                isForGiftCard={isForGiftCard}
                confirmDeletePaymentMethodIsVisible={
                  confirmDeletePaymentMethodIsVisible
                }
                requestingDeletePaymentMethod={requestingDeletePaymentMethod}
              />
            )}
            <ChangeButton
              id='CartPaymentMethod-ChangeButton'
              onClick={handleChangePaymentMethod}
            >
              {filteredPaymentMethods && filteredPaymentMethods.length > 0 ? (
                <CalloutWrapper>
                  {preferredPaymentMethod?.type === 'gift_card'
                    ? 'Select a payment method'
                    : 'Change'}
                </CalloutWrapper>
              ) : null}
            </ChangeButton>
          </PaymentMethodPreviewWrapper>
        ) : (
          <AddNewPaymentMethodButton
            id='CartPaymentMethod-NewPaymentMethodButton'
            isForCheckoutPage={false}
            noDialogBackground={noDialogBackground}
            showChangePaymentMethodButton
            showSelectPaymentMethodForm={(bool) =>
              showSelectPaymentMethodForm(bool)
            }
          />
        )}
      </Box>
      <PaymentMethodFormContainer />
      {!isGiftCardModalVisible && isPayOnArrival && (
        <SelectPaymentMethodFormContainer />
      )}

      <ConfirmDelete
        handleCancelDeletePaymentMethod={handleCancelDeletePaymentMethod}
        confirmDeletePaymentMethodIsVisible={
          confirmDeletePaymentMethodIsVisible
        }
        requestingDeletePaymentMethod={requestingDeletePaymentMethod}
        handleDeletePaymentMethod={handleDeletePaymentMethod}
      />
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  validatedCart: state.cartReducer.validatedCart,
  isGiftCardModalVisible: state.giftCardReducer.isGiftCardModalVisible,
});

export default connect(mapStateToProps)(CartPaymentMethod);
